import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventItemService {
  constructor(private data: DataService) {}

  getAll(): Observable<any> {
    return this.data.get('event-item');
  }

  getEventItemById(id: number): Observable<any> {
    return this.data.get(`event-item/${id}`);
  }
  saveEvent(event: FormData, message?: string) {
    return this.data.post('event-item', event, message);
  }

  updateEvent(events: any, message?: string) {
    return this.data.put('event-item', events, message);
  }

  deleteEvent(id: number, message?: string) {
    return this.data.delete(`event-item/${id}`, message);
  }
}
